













































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import BaseCard from '@/modules/shared/components/shared/base/BaseCard.vue'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import { DepartmentRequestModel } from '@/modules/department/models/department-request.model'
import AdminDepartmentChatId from '@/modules/department/components/admin/AdminDepartmentChatId.vue'
import AdminAgentSearch from '@/modules/user/components/admin/AdminAgentSearch.vue'

@Component({
  components: {
    AdminAgentSearch,
    AdminDepartmentChatId,
    Toggle,
    BaseInput,
    BaseButton,
    BaseCard
  }
})
export default class AdminDepartmentBaseForm extends Vue {
  @Prop({ default: false }) chatIdActivate: boolean
  @Prop({ default: false }) loading: boolean
  @Prop({ default: false }) footerSeparator: boolean

  protected __loadingState: boolean = false

  protected telegramActivationCode: string = null

  protected supporterSearchDefault: number[] = []

  protected requestData: DepartmentRequestModel = {
    active: true,
    auto_message: null,
    chat_id: null,
    contactable: true,
    description: null,
    send_auto_message: false,
    supporters: null,
    title: null
  }

  protected get loadingState() {
    return this.loading || this.__loadingState
  }

  protected setValue(key, value) {
    this.$set(this.requestData, key, value)
  }

  protected onSubmit() {
  }
}
